import { cx } from '@linaria/core';
import { useQuery } from '@tanstack/react-query';
import { memo } from 'react';
import { USER_AREA_BASE_PATH } from '@pm2/api';
import { NotificationCount } from '@pm2/react-utils';
import { getStatusForProductQuery, useGetNotificationsQuery, isNotificationConsideredRecent } from '@pm2/user-area';
import { useAppContext } from '@provider/app-context';
import { Link } from '@provider/navigation';
import { Tooltip, UserIcon } from '@ui/kit';
import { Snackbar } from './Snackbar/Snackbar.js';
import { guideBubbleWrapperCls, toolButtonCls } from './root.tools.style.js';
import { notificationBadge, buttonCls } from './tool.user-area.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const UserAreaToolNonMemoized = () => {
  const productId = useAppContext(state => state.product?.isbn);
  const status = useQuery(getStatusForProductQuery(productId));
  const notifications = useGetNotificationsQuery();
  const notificationCount = (status.data?.length ?? 0) + (notifications.data?.filter(it => it.type !== "dialog" && isNotificationConsideredRecent(it)).length ?? 0);
  const urgentNotifications = status.data?.filter(it => it.urgent);
  const showNotifications = notificationCount > 0;
  return /*#__PURE__*/jsxs("div", {
    className: guideBubbleWrapperCls,
    children: [/*#__PURE__*/jsx(Tooltip, {
      placement: "bottom",
      offsetPx: 0,
      body: "Min profil: besvarelser, mine forl\xF8b og indstillinger",
      ariaType: "label",
      children: ref => /*#__PURE__*/jsxs(Link, {
        ref: ref,
        className: cx(toolButtonCls, buttonCls),
        href: `${USER_AREA_BASE_PATH}/besvarelser`,
        children: [/*#__PURE__*/jsx("span", {
          children: /*#__PURE__*/jsx(UserIcon, {
            height: 22
          })
        }), /*#__PURE__*/jsx(NotificationCount, {
          className: notificationBadge,
          active: showNotifications
        })]
      })
    }), /*#__PURE__*/jsx(Snackbar, {
      notifications: urgentNotifications
    })]
  });
};
const UserAreaTool = /*#__PURE__*/memo(UserAreaToolNonMemoized);

export { UserAreaTool };
//# sourceMappingURL=tool.user-area.js.map
